import React from "react"

import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer"

import SearchBar from "./SearchBar"

import { Link } from "gatsby"

import "./contactButton.scss"

const ContactButton = (props) => {
  const { color } = props
  return (
    <div className="contact-wrapper">
      <SearchBar color={color} />
      <Link to="/contact-us">
        <div className="contact-button" style={{ color: color }}>
          <QuestionAnswerIcon />
          <span>Kapcsolat</span>
        </div>
      </Link>
    </div>
  )
}

export default ContactButton
